<template>
  <div class="author-btns" v-if="allItemDesc.length > 1">
    <div
      v-for="(author, index) in authors"
      :key="author.title"
      class="title"
      :class="{
        title_active: author.id === activeItemDesc.id,
      }"
      @click="changeAuthor(index)"
    >
      {{ $t(author.title) }}
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  authors: any;
  activeItemDesc: any;
  allItemDesc: any;
}>();

const emit = defineEmits<{
  (e: 'change-author', index: number): void;
}>();

const changeAuthor = (index: number) => {
  emit('change-author', index);
};
</script>

<style scoped lang="scss">
.author-btns {
  position: absolute;
  bottom: 8px;
  color: white;
  left: 50%;
  transform: translateX(-50%);
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: $g-2;

  .title {
    border-radius: 25px;
    text-align: center;
    @include launcher-p5;
    width: 120px;
    height: 18px;
    cursor: pointer;
    background: rgba(white, 0.2);
    color: var(--var-white-000);
    opacity: 0.9;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    line-clamp: 1;
    -webkit-box-orient: vertical;
    line-height: 18px;

    &_active {
      background: var(--var-white-000);
      color: var(--var-black-100);
    }
  }

  @media (max-width: 720px) {
    position: absolute;
    display: flex;
    bottom: 0;
    height: fit-content;
    max-width: 100%;
    overflow-x: auto;
    gap: 0;
    margin-top: 10px;
    left: 0;
    transform: translateX(0);
    -ms-overflow-style: none;
    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none;
    }

    .title {
      flex: 0 0 auto;
      background: none;
      border-bottom: 1px solid #e1e5f0;
      color: #839aaf;
      border-radius: 0;
      padding: 8px 12px;
      height: auto;
      width: auto;
      white-space: nowrap;

      &_active {
        background: none;
        color: var(--var-blue-50);
        border-bottom: 1px solid var(--var-blue-50);
      }
    }
  }
}
</style>
